"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryTabPanel = void 0;
const core_1 = require("@material-ui/core");
const React = require("react");
const react_redux_1 = require("react-redux");
const StoryEditorDuck_1 = require("../../Ducks/StoryEditorDuck");
const StoryPreview_1 = require("./StoryPreview/StoryPreview");
const Graph = require('graphology');
const mapStateToProps = (state) => ({
    stories: state.stories,
    storyEditor: state.storyEditor
});
const mapDispatchToProps = dispatch => ({
    openStoryEditor: visible => dispatch(StoryEditorDuck_1.openStoryEditor(visible))
});
const connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
const useStyles = core_1.makeStyles((theme) => ({
    title: {
        margin: theme.spacing(0, 0, 2),
    },
    list: {
        maxHeight: 400,
        overflow: 'auto'
    }
}));
exports.StoryTabPanel = connector(({ stories, openStoryEditor, storyEditor }) => {
    const classes = useStyles();
    return React.createElement(core_1.Grid, { container: true, spacing: 0, direction: "column", alignItems: "stretch" },
        React.createElement(core_1.Grid, { item: true },
            React.createElement(core_1.Box, { p: 2 },
                React.createElement(core_1.Typography, { variant: "h6", className: classes.title }, "Story Books"),
                React.createElement(StoryPreview_1.StoryPreview, null))));
});
